<div style="display:flex; height:100%; width:100%">
  <div style="flex: 1 auto" class="no-nav-layout" [ngStyle]="themeManager.getUnderlayStyle(true)">
    <mat-toolbar class="mat-elevation-z2" style="padding-bottom:0px; position:relative">
      <span *ngIf="_sessionService.getEnvNotification().label" matBadge="?" matBadgeSize="small" matBadgeColor="warn" [matTooltip]="_sessionService.getEnvNotification().desc">{{_sessionService.getEnvNotification().label}}</span>
      <a class="logo" [routerLink]="['/secured']" style="position: absolute; top:50%; transform: translateY(-50%); left: 0; right: 0; margin: auto;height: 50px; width: 250px;">
        <img src="{{themeManager.getLayoutLogo()}}" style='width:250px;'>
      </a>

      <div style="margin:0 0 0 auto;">
        <button mat-icon-button style="margin:0;" (click)="openSupport()">
          <mat-icon matTooltip="Help" matTooltipPosition="left">help</mat-icon>
        </button>
        <button matTooltip="Account Options" matTooltipPosition="left" mat-icon-button [matMenuTriggerFor]="profileMenu">
          <mat-icon>account_circle</mat-icon>
        </button>
      
        <mat-menu #profileMenu="matMenu" [overlapTrigger]="false">
          <button mat-menu-item color="primary" (click)="onMyProfileClicked()">
            <mat-icon color="primary">account_circle</mat-icon>
            <span>My Profile</span>
          </button>
          <button *ngIf="_sessionService.getApiCredentials().length>1" mat-menu-item [routerLink]="['/secured/accountSelection']" color="primary">
            <mat-icon color="primary">swap_horiz</mat-icon>
            <span>Switch Account</span>
          </button>
          <button mat-menu-item [routerLink]="['/public/logout']" color="primary">
            <mat-icon color="primary">exit_to_app</mat-icon>
            <span>Log Out</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>
    <router-outlet></router-outlet>
  </div>
</div>